<template>
  <div>
    <a-button class="m-b-20" type="primary" @click="create">
      <PlusOutlined />
      新增字段
    </a-button>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns'
      :data-source='list' :scroll="{ x: 'max-content'}">
      <template v-slot:action="{ record }">
          <a-button type="danger" size="small" href="javascript:;"  @click="edit(record)" v-if="!record.is_sys" class="m-r-10">修改</a-button>
     
          <a-button type="danger" size="small" href="javascript:;"  @click="delCustimizes(record)" v-if="!record.is_sys" class="m-r-10"> 删除</a-button>
        <div v-else>系统默认数据,不支持修改</div>
      </template>
    </a-table>
      <a-modal  :keyboard="false" v-model:visible="visible" :title="form.id?'修改':'新增'+'字段'" centered  @ok="handleOk" destroyOnClose>
         <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="{span:4}" :wrapper-col="{span:18}">
            <a-form-item label="字段名称" required name="customize_name">
              <a-input v-model:value="form.customize_name"></a-input>
            </a-form-item>
            <a-form-item label="字段类型" required >
                <a-select v-model:value="form.type_id" style="width: 100%" @focus="focus" ref="select" @change="changeType">
                  <a-select-option :value="v.type_id" v-for="(v,k) in options" :key="k">{{v.type_name}}</a-select-option>
                </a-select>
            </a-form-item>
            <!-- type_id ==1 输入框  type_id==2单选框 type_id==3 多选框  type_id==4 日期选择框 type_id==5手机 type_id==6 手机带验证码 -->
            <a-form-item label="下拉选项" v-show="form.type_id==2"  name='single_options' required help="选项1/选项2/选项3">
              <a-input placeholder="选项1/选项2/选项3" v-model:value="form.single_options"></a-input>
            </a-form-item>
            <a-form-item label="下拉选项" v-show="form.type_id==3" name='many_options' help="选项1/选项2/选项3">
              <a-input placeholder="选项1/选项2/选项3" v-model:value="form.many_options"></a-input>
            </a-form-item>
            <a-form-item label="输入长度" v-show="form.type_id==1"  name='length'>
              <a-input-number :precision="0" v-model:value="form.length"></a-input-number>
            </a-form-item>
            <a-form-item label="输入提示" name="placeholder_text" required>
              <a-input v-model:value="form.placeholder_text" placeholder="输入提示"></a-input>
            </a-form-item>
            <!-- <a-form-item label="排序" name="sort" required>
              <a-input-number :precision="0" v-model:value="form.sort"></a-input-number>
            </a-form-item> -->
        <a-form-item label="状态">
          <a-radio-group v-model:value="form.is_enable">
            <a-radio :value="1">
              启用
            </a-radio>
            <a-radio :value="0">
              禁用
            </a-radio>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import {activitysFourCustomizesList,activitysFourCustomizesCreate,activitysFourCustomizestypeOption,activitysFourCustomizestypeUpdate,activitysFourCustomizestypeDetail,activitysFourCustomizestypeDelete} from '@/api/qrcodeActivitys'
import {number2Boolean,boolean2Number} from '@/libs/util'
import { iscode } from '@/utils/app';
import { message, Modal } from 'ant-design-vue';
let columns = [
  {
    title: "字段名称",
    dataIndex: "customize_name",
    key: "customize_name",
  },
  {
    title: "输入提示",
    dataIndex: "placeholder_text",
    key: "placeholder_text",
  },
  {
    title: "类型",
    key: "type_name",
    dataIndex: "type_name"
  },
  {
    title: "状态",
    dataIndex: "is_enable",
    key: "is_enable",
    customRender:({record})=>{
        return record.is_enable?'启用':'禁用'
    } 
  },
  {
    title: "操作",
    key: "action",
    width: 290,
    slots: { customRender: "action" },
  },
];

  export default {
    setup(props,{emit}) {
      const listLoading = ref(false);
      const list = ref([]);
      const initData = async () => {
        listLoading.value = true
        let result = await activitysFourCustomizesList().then(res => res.data).catch(error => error)
        listLoading.value = false
        if (iscode(result)) {
          list.value = result.data
        }
      }
    const options=ref([])
    const getOption=async()=>{
     let result=await activitysFourCustomizestypeOption().then(res=>res.data).catch(error=>error)
     options.value=result.data
    }
    onMounted(()=>{
      initData()
      getOption()
    })
    const visible=ref(false)
    const ruleForm=ref()
    const form=ref({
        length:null,//输入长度
        customize_name:'',//字段名
        type_id:'',//字段类型
        sort:0,//排序
        single_options:'',//单选 选择选项
        many_options:'',//多选 选择选项
        is_enable:0
    })
    const create=()=>{
      visible.value=true
      form.value={
        length:null,//输入长度
        customize_name:'',//字段名
        type_id:'',//字段类型
        sort:0,//排序
        single_options:'',//单选 选择选项
        many_options:'',//多选 选择选项
        is_enable:0
        }
    }
    const handleOk=async()=>{
      if(!form.value.type_id){
        message.error('请选择字段类型')
        return
      }
      let result
      if(form.value.id){
       result=await activitysFourCustomizestypeUpdate(form.value.id,{
        ...form.value,
        is_enable:boolean2Number(form.value.is_enable)
      }).then(res=>res.data).catch(error=>error)
      }else{
         result=await activitysFourCustomizesCreate({
        ...form.value,
        is_enable:boolean2Number(form.value.is_enable)
      }).then(res=>res.data).catch(error=>error)
      }

      if(iscode(result,true)){
            visible.value=false
            initData()
            emit('update',1)
      }
    }
    const type_mark=ref('')
    const changeType=(e)=>{
      var opt=options.value.find(v=>v.type_id==e)
      type_mark.value=opt.type_mark
      form.value.type_id=e
    }
    const rules={
      length:[
        {require:true,message:'请输入输入长度',type:'number'}
      ],
      single_options:[
        {require:true,message:"请输入单选选项"}
      ],
      many_options:[
        {require:true,message:"请输入多选选项"}
      ],
      placeholder_text:[
        {require:true,message:"请输入输入提示"}
      ]
    }
    var customizesDetail=ref({})
    const edit=async(data)=>{
       let result = await activitysFourCustomizestypeDetail(data.id)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result)) {
        customizesDetail.value=result.data
        form.value=result.data
        visible.value=true
      }
    }
    // 字段删除
    const delCustimizes=async (data)=>{
      Modal.confirm({
        centered: true,
        content: "删除后无法恢复，您确定要吗？",
        onOk: async () => {
          let result=await activitysFourCustomizestypeDelete(data.id).then(res=>res.data).catch(error=>error)
          if (iscode(result, true)) {
            initData()
            getOption()
          }
        },
      });
     
    }
    return {
      columns,
      listLoading,
      list,
      visible,
      create,
      ruleForm,
      form,
      handleOk,
      rules,
      options,
      changeType,
      type_mark,
      edit,
      delCustimizes
    };
  },
};
</script>